module.exports = "/_next/static/images/og-image-49523962f23f5e3dcc2bf6dc246189bd.png";